<template lang="pug">
  v-slide-y-transition(mode="out-in")
    v-container(fluid)

      confirm(ref="deleteConfirm")

      v-btn(text, color="primary" class="right", to="/commercial_chains/create") Añadir nuevo grupo

      v-data-table.mt-2(:headers="tableHeaders", :items="commercial_chains", disable-pagination, hide-default-footer, class="elevation-1")
        template(v-slot:item.commission="{item}") {{ item.commission | number }}%
        template(v-slot:item.options="{item}")
          v-btn(:to="`/commercial_chains/${item.id}/edit`", text, icon, color="primary")
            v-icon edit
          v-btn(@click="handleDelete(item)", text, icon, color="red")
            v-icon delete
</template>

<style scoped>
</style>

<script>
  module.exports = {
    data() {
      return {
        rowsPerPage: [25, 50, 100, { text: 'Todo', value: -1 }],
        loading: false,
        commercial_chains: [],
        tableHeaders: [
          {
            text: 'Nombre grupo',
            align: 'left',
            sortable: true,
            value: 'name',
          },
          {
            text: 'Comisión',
            align: 'left',
            sortable: true,
            value: 'commission',
          },
          {
            text: 'Opciones',
            align: 'right',
            sortable: false,
            value: 'options',
          },
        ],
      };
    },
    created() {
      this.fetchData();
    },
    methods: {
      fetchData() {
        this.loading = true;
        api.get('/commercial_chains').then((res) => {
          this.commercial_chains = res.data;
        }).catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
        }).finally(() => {
          this.loading = false;
        });
      },
      handleDelete(item) {
        this.$refs.deleteConfirm.open('Eliminar', '¿Estás seguro?').then((confirm) => {
          if (confirm) {
            api.delete(`/commercial_chains/${item.id}`).then(() => {
              this.commercial_chains.splice(this.commercial_chains.indexOf(item), 1);
            }).catch(this.handleError);
          }
        });
      },
      handleError(err) {
        // eslint-disable-next-line no-console
        console.error(err);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/CommercialChains/CommercialChains.vue